const defaultImage = "/defaultPictureImage.png";

const getUrlBlobContainerImage = (pictureFileName: string) => {
  return `https://catacapstorage.blob.core.windows.net/prodcontainer/${pictureFileName}`;
};

export { defaultImage, getUrlBlobContainerImage };
